import React, { FC } from 'react'
import ArrowIcon from './ArrowIcon'
import WaveIcon from './WaveIcon'

interface StatsContainerProps {
	percent: number
	number: number
	title: string
}

const StatsContainer: FC<StatsContainerProps> = ({ percent, number, title }) => (
	<div className="bg-brand-primary-md rounded-xl text-white p-5 relative max-w-[280px] w-full">
		<div className="flex items-center gap-1.5 absolute right-2 top-2 md:top-3 md:right-3">
			<ArrowIcon fall={percent < 0} />
			<span className="text-sm">{percent} %</span>
		</div>
		<div className="flex items-center gap-1 mb-2 -mt-2 text-3xl font-semibold md:text-5xl">
			{number} <p className="text-xs font-semibold text-white opacity-50">/month</p>
		</div>
		<div className="w-2/3 text-xs font-semibold uppercase md:w-auto md:text-sm">{title}</div>
		<WaveIcon className="absolute left-0 w-full -bottom-3" />
	</div>
)

export default StatsContainer
